import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { Volume } from '../../curriculum';
import { AdvancePlanningSection } from '../models/advancePlanning';

type VolumeWithPlanningMaterials = Volume & {
  sections: AdvancePlanningSection[];
};

export const getAdvancePlanningMaterials = (curriculumId: string) => {
  return cacheableRequest(`/v1/org/curriculum/${curriculumId}/adv-plan/volumes`).then(
    (response: AxiosResponse<VolumeWithPlanningMaterials[]>) => response.data
  );
};
